import { useTranslation } from "react-i18next";
import { CDocument } from "../../../models/Document";
import { ConfirmationModal } from "../../ConfirmationModal";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        document?: CDocument;
    };
    onClose: () => void;
    deleteDocument: (document: CDocument) => void
}

export const DeleteClientDocumentModal: React.FC<Props> = ({
    info,
    onClose,
    deleteDocument
}) => {

    const { t } = useTranslation();

    const onDeleteDocument = () => {
        deleteDocument(info.document!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_DOCUMENT")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteDocument }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_DOCUMENT_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}